<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome do profissional"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="getRowColor"
          :items="indexedItems"
          :search="search"
          item-key="id"
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->

          <template v-slot:header.qtd_visitas_acs="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Quantidade de visitas domiciliares por profissional ACS ou TACS."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.qtd_visitas_equipe="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Quantidade de visitas domiciliares por equipe onde o profissional ACS ou TACS está lotado."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.qtd_visitas_municipio="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Quantidade de visitas domiciliares no município."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.ultima_visita="{ item }">
            <span v-if="item.dt_dados == null"> +30 dias </span>
            <span v-else>
              {{ formatDate(item.dt_dados) }}
            </span>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} profissionais</span
            >
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Profissional ACS',
          align: 'start',
          filterable: true,
          value: 'no_profissional',
          sortable: false,
        },
        {
          text: 'Unidade de Saúde',
          align: 'start',
          filterable: false,
          value: 'no_unidade_saude',
          sortable: false,
        },
        {
          text: 'Última visita',
          align: 'start',
          filterable: false,
          value: 'ultima_visita',
          sortable: true,
        },
        {
          text: 'Microárea',
          align: 'start',
          filterable: false,
          value: 'qtd_visitas_acs',
          sortable: true,
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: false,
          value: 'qtd_visitas_equipe',
          sortable: true,
        },
        {
          text: 'Município',
          align: 'start',
          filterable: false,
          value: 'qtd_visitas_municipio',
          sortable: true,
        },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {
      let diff = this.diffDays(item.dt_dados)
      if (diff > 8 || item.dt_dados == null) {
        return 'color-red'
      } else {
        return 'color-green'
      }
    },
  },
}
</script>

<style></style>
